import React from 'react'

export const GooglePaid = () => {
    return (
        <svg
            viewBox="0 0 256 230"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid">
            <g>
                <path
                    d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
                    fill="#FBBC04"
                />
                <path
                    d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
                    fill="#4285F4"
                />
                <ellipse
                    fill="#34A853"
                    cx="42.6637241"
                    cy="187.924414"
                    rx="42.6637241"
                    ry="41.6044138"
                />
            </g>
        </svg>
    )
}

export const GoogleSearch = () => {
    return (
        <svg width={24} focusable="false" viewBox="0 0 24 24">
            <path fill="#34a853" d="M10 2v2a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8"></path>
            <path fill="#ea4335" d="M10 4V2a8 8 0 0 0-8 8h2c0-3.3 2.7-6 6-6"></path>
            <path fill="#fbbc04" d="M4 10H2a8 8 0 0 0 8 8v-2c-3.3 0-6-2.69-6-6"></path>
            <path
                fill="#4285f4"
                d="M22 20.59l-5.69-5.69A7.96 7.96 0 0 0 18 10h-2a6 6 0 0 1-6 6v2c1.85 0 3.52-.64 4.88-1.68l5.69 5.69L22 20.59"></path>
        </svg>
    )
}

export const BingPaid = () => {
    return (
        <svg width={24} viewBox="213 138.2 598 747.6" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m435 332 76.2 165.1 112.4 50.7-405.7 213.4 166.3-148v-422.5l-171.2-52.5v628.4l170.2 119.2 427.8-255v-183.7z"
                fill="#00897b"
            />
        </svg>
    )
}

export const Bing = () => {
    return (
        <svg
            width={24}
            viewBox="0 0 256 320"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid">
            <g>
                <path
                    d="M95.055,82.908 L127.636,153.555 L175.78,175.332 L2.125,266.695 L73.279,203.267 L73.279,22.449 L0,0 L0,268.932 L72.83,319.986 L256,210.88 L256,132.227 L95.055,82.908"
                    fill="#F4BD27"
                />
            </g>
        </svg>
    )
}

export const Awin = () => (
    <svg
        width={24}
        version="1.0"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 255.1 113.4"
        style={{ enableBackground: 'new 0 0 255.1 113.4' }}>
        <style type="text/css">
            {
                '.st0{fill:#FF262E;} .st1{fill:#FAB418;} .st2{fill:#DE0833;} .st3{fill:#FF6600;} .st4{fill:#23282C;} .st5{fill:#B41831;}'
            }
        </style>
        <g>
            <path
                className="st0"
                d="M33.57,32.59L13.83,15.67c-0.63-0.54-1.59,0.05-1.39,0.86l7.8,31.38l15.01,8.87L33.57,32.59z"
            />
            <path
                className="st1"
                d="M33.86,96.22c-0.3,0.79-1.43,0.72-1.63-0.09L20.24,47.91L1.3,36.73c-0.72-0.42-1.56,0.32-1.22,1.09
		l33.25,74.95c0.34,0.77,1.47,0.64,1.62-0.19l7.23-38.45l-0.12,0.21L33.86,96.22z"
            />
            <path
                className="st2"
                d="M33.89,96.16l8.2-21.89l-3.59,6.08c-0.43,0.72-1.53,0.46-1.59-0.38l-1.63-23.27l-15.01-8.86l11.99,48.22
		C32.47,96.88,33.6,96.95,33.89,96.16z"
            />
            <path
                className="st3"
                d="M59.89,33.02L32.86,0.21c-0.53-0.64-1.57-0.23-1.51,0.61l2.22,31.78l13.71,11.76
		c2.73,2.34,3.71,6.15,2.45,9.53l-7.49,20l-0.05,0.24l18.47-31.28C62.49,39.74,62.18,35.81,59.89,33.02z"
            />
            <path
                className="st2"
                d="M39.25,59.14c3.11,1.84,4.73,5.42,4.06,8.97l-1.08,5.77l7.49-20c1.26-3.37,0.29-7.18-2.45-9.53L33.56,32.6
		l1.69,24.18L39.25,59.14z"
            />
            <path
                className="st4"
                d="M86.48,44.68h1.26c1.71,0,3.24,1.05,3.86,2.64l18.94,48.38h-5.69c-1.03,0-1.96-0.64-2.33-1.61l-5.18-13.63
		H76.65l-5.07,13.62c-0.36,0.97-1.29,1.62-2.33,1.62h-5.49l18.85-48.38C83.24,45.73,84.78,44.68,86.48,44.68z M78.86,74.35h16.2
		l-8.1-21.57L78.86,74.35z"
            />
            <path className="st4" d="M192.69,95.69V44.68h6.92V95.7L192.69,95.69L192.69,95.69z" />
            <path
                className="st4"
                d="M248.63,93.93l-26.66-37.94V95.7h-6.4V44.73h4.04c1.35,0,2.61,0.65,3.38,1.75l25.71,36.3V44.69l6.4-0.01V95.7
		h-3.07C250.67,95.69,249.4,95.04,248.63,93.93z"
            />
            <path
                className="st4"
                d="M165.55,95.69h-5.82l-13.77-41.37L132.2,95.69h-5.74l-15.33-51.02h5.52c1.12,0,2.1,0.74,2.4,1.82l10.65,38.08
		l12.26-37.75c0.42-1.28,1.61-2.15,2.96-2.15h2.4c1.35,0,2.54,0.87,2.96,2.15l12.26,37.75l10.61-38.08c0.3-1.08,1.28-1.82,2.4-1.82
		h5.33L165.55,95.69z"
            />
            <path
                className="st5"
                d="M39.25,59.14l-4-2.36l1.63,23.26c0.06,0.84,1.16,1.1,1.59,0.38l3.59-6.08l0,0l0.12-0.21l0.04-0.24l0,0
		l1.08-5.77C43.99,64.56,42.36,60.97,39.25,59.14z"
            />
        </g>
    </svg>
)

export const FacebookPaid = ({ style = undefined }) => (
    <svg
        style={style}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24">
        <path
            d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z"
            fill="#1977f3"
        />
    </svg>
)

export const InstagramPaid = ({ style = undefined }) => (
    <svg
        style={style}
        width={24}
        enableBackground="new 0 0 24 24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <linearGradient
            id="SVGID_1_"
            gradientTransform="matrix(0 -1.982 -1.844 0 -132.522 -51.077)"
            gradientUnits="userSpaceOnUse"
            x1="-37.106"
            x2="-26.555"
            y1="-72.705"
            y2="-84.047">
            <stop offset="0" stopColor="#fd5" />
            <stop offset=".5" stopColor="#ff543e" />
            <stop offset="1" stopColor="#c837ab" />
        </linearGradient>
        <path
            d="m1.5 1.633c-1.886 1.959-1.5 4.04-1.5 10.362 0 5.25-.916 10.513 3.878 11.752 1.497.385 14.761.385 16.256-.002 1.996-.515 3.62-2.134 3.842-4.957.031-.394.031-13.185-.001-13.587-.236-3.007-2.087-4.74-4.526-5.091-.559-.081-.671-.105-3.539-.11-10.173.005-12.403-.448-14.41 1.633z"
            fill="url(#SVGID_1_)"
        />
        <path
            d="m11.998 3.139c-3.631 0-7.079-.323-8.396 3.057-.544 1.396-.465 3.209-.465 5.805 0 2.278-.073 4.419.465 5.804 1.314 3.382 4.79 3.058 8.394 3.058 3.477 0 7.062.362 8.395-3.058.545-1.41.465-3.196.465-5.804 0-3.462.191-5.697-1.488-7.375-1.7-1.7-3.999-1.487-7.374-1.487zm-.794 1.597c7.574-.012 8.538-.854 8.006 10.843-.189 4.137-3.339 3.683-7.211 3.683-7.06 0-7.263-.202-7.263-7.265 0-7.145.56-7.257 6.468-7.263zm5.524 1.471c-.587 0-1.063.476-1.063 1.063s.476 1.063 1.063 1.063 1.063-.476 1.063-1.063-.476-1.063-1.063-1.063zm-4.73 1.243c-2.513 0-4.55 2.038-4.55 4.551s2.037 4.55 4.55 4.55 4.549-2.037 4.549-4.55-2.036-4.551-4.549-4.551zm0 1.597c3.905 0 3.91 5.908 0 5.908-3.904 0-3.91-5.908 0-5.908z"
            fill="#fff"
        />
    </svg>
)

export const FacebookMessengerPaid = ({ style = undefined }) => (
    <svg
        style={style}
        width={24}
        viewBox="0 0 1000 999.99072"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="none" transform="translate(-0.940002,-0.91)">
            <path
                d="m 1000.94,485.90553 c 0,278.68297 -218.33611,484.99554 -500.00001,484.99554 -50.58364,0 -99.1207,-6.66838 -144.74082,-19.2103 -8.86599,-2.45104 -18.28875,-1.75604 -26.70037,1.94548 l -99.24741,43.81288 c -25.95418,11.46807 -55.25663,-6.99732 -56.12697,-35.36414 l -2.72879,-88.95303 C 171.05517,862.18098 166.12877,851.925 157.95777,844.63842 60.667611,757.62959 0.940002,631.68181 0.940002,485.90553 0.940002,207.23536 219.27609,0.91 500.93999,0.91 782.60389,0.91 1000.94,207.23536 1000.94,485.90553 Z"
                fill="#0866ff"
                style={{ strokeWidth: 12.7992 }}
            />
            <path
                d="M 636.7009,625.519 810.78129,356.48533 c 17.50544,-27.04083 -14.91617,-58.51529 -41.42711,-40.22782 l -181.7215,125.3411 c -6.12569,4.23141 -14.19685,4.34532 -20.43517,0.30334 L 405.91119,337.55278 c -13.65289,-8.82887 -31.87892,-4.9264 -40.70652,8.72649 L 191.11149,615.32573 c -17.50544,27.04083 14.91617,58.5153 41.42583,40.22655 L 414.29721,530.19966 c 6.12569,-4.23141 14.19685,-4.34532 20.44797,-0.30334 l 161.26073,104.34916 c 13.65416,8.82888 31.87892,4.92641 40.70779,-8.72648 z"
                fill="#ffffff"
                style={{ strokeWidth: 12.7992 }}
            />
        </g>
    </svg>
)

export const Meta = () => (
    <svg width={24} viewBox="0 0 290 191" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient
                id="Grad_Logo1"
                x1="61"
                y1="117"
                x2="259"
                y2="127"
                gradientUnits="userSpaceOnUse">
                <stop style={{ stopColor: '#0064e1' }} offset="0" />
                <stop style={{ stopColor: '#0064e1' }} offset="0.4" />
                <stop style={{ stopColor: '#0073ee' }} offset="0.83" />
                <stop style={{ stopColor: '#0082fb' }} offset="1" />
            </linearGradient>
            <linearGradient
                id="Grad_Logo2"
                x1="45"
                y1="139"
                x2="45"
                y2="66"
                gradientUnits="userSpaceOnUse">
                <stop style={{ stopColor: '#0082fb' }} offset="0" />
                <stop style={{ stopColor: '#0064e0' }} offset="1" />
            </linearGradient>
        </defs>
        <path
            style={{ fill: '#0081fb' }}
            d="m31.06,125.96c0,10.98 2.41,19.41 5.56,24.51 4.13,6.68 10.29,9.51 16.57,9.51 8.1,0 15.51-2.01 29.79-21.76 11.44-15.83 24.92-38.05 33.99-51.98l15.36-23.6c10.67-16.39 23.02-34.61 37.18-46.96 11.56-10.08 24.03-15.68 36.58-15.68 21.07,0 41.14,12.21 56.5,35.11 16.81,25.08 24.97,56.67 24.97,89.27 0,19.38-3.82,33.62-10.32,44.87-6.28,10.88-18.52,21.75-39.11,21.75l0-31.02c17.63,0 22.03-16.2 22.03-34.74 0-26.42-6.16-55.74-19.73-76.69-9.63-14.86-22.11-23.94-35.84-23.94-14.85,0-26.8,11.2-40.23,31.17-7.14,10.61-14.47,23.54-22.7,38.13l-9.06,16.05c-18.2,32.27-22.81,39.62-31.91,51.75-15.95,21.24-29.57,29.29-47.5,29.29-21.27,0-34.72-9.21-43.05-23.09-6.8-11.31-10.14-26.15-10.14-43.06z"
        />
        <path
            style={{ fill: 'url(#Grad_Logo1)' }}
            d="m24.49,37.3c14.24-21.95 34.79-37.3 58.36-37.3 13.65,0 27.22,4.04 41.39,15.61 15.5,12.65 32.02,33.48 52.63,67.81l7.39,12.32c17.84,29.72 27.99,45.01 33.93,52.22 7.64,9.26 12.99,12.02 19.94,12.02 17.63,0 22.03-16.2 22.03-34.74l27.4-.86c0,19.38-3.82,33.62-10.32,44.87-6.28,10.88-18.52,21.75-39.11,21.75-12.8,0-24.14-2.78-36.68-14.61-9.64-9.08-20.91-25.21-29.58-39.71l-25.79-43.08c-12.94-21.62-24.81-37.74-31.68-45.04-7.39-7.85-16.89-17.33-32.05-17.33-12.27,0-22.69,8.61-31.41,21.78z"
        />
        <path
            style={{ fill: 'url(#Grad_Logo2)' }}
            d="m82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78-12.33,18.61-19.88,46.33-19.88,72.95 0,10.98 2.41,19.41 5.56,24.51l-26.48,17.44c-6.8-11.31-10.14-26.15-10.14-43.06 0-30.75 8.44-62.8 24.49-87.55 14.24-21.95 34.79-37.3 58.36-37.3z"
        />
        <path
            style={{ fill: '#192830' }}
            d="m347.94,6.04h35.93l61.09,110.52 61.1-110.52h35.15v181.6h-29.31v-139.18l-53.58,96.38h-27.5l-53.57-96.38v139.18h-29.31z m285.11,67.71c-21.02,0-33.68,15.82-36.71,35.41h71.34c-1.47-20.18-13.11-35.41-34.63-35.41z m-65.77,46.57c0-41.22 26.64-71.22 66.28-71.22 38.99,0 62.27,29.62 62.27,73.42v8.05h-99.49c3.53,21.31 17.67,35.67 40.47,35.67 18.19,0 29.56-5.55 40.34-15.7l15.57,19.07c-14.67,13.49-33.33,21.27-56.95,21.27-42.91,0-68.49-31.29-68.49-70.56z m164.09-43.97h-26.98v-24h26.98v-39.69h28.28v39.69h40.99v24h-40.99v60.83c0,20.77 6.64,28.15 22.96,28.15 7.45,0 11.72-.64 18.03-1.69v23.74c-7.86,2.22-15.36,3.24-23.48,3.24-30.53,0-45.79-16.68-45.79-50.07z m188.35,23.34c-5.68-14.34-18.35-24.9-36.97-24.9-24.2,0-39.69,17.17-39.69,45.14 0,27.27 14.26,45.27 38.53,45.27 19.08,0 32.7-11.1 38.13-24.91z m28.28,87.95h-27.76v-18.94c-7.76,11.15-21.88,22.18-44.75,22.18-36.78,0-61.36-30.79-61.36-70.95 0-40.54 25.17-70.83 62.92-70.83 18.66,0 33.3,7.46 43.19,20.63v-17.38h27.76z"
        />
    </svg>
)

export const FacebookOrganic = () => <FacebookPaid style={{ filter: 'hue-rotate(100deg)' }} />
export const InstagramOrganic = () => <InstagramPaid style={{ filter: 'hue-rotate(100deg)' }} />
export const FacebookMessengerOrganic = () => (
    <FacebookMessengerPaid style={{ filter: 'hue-rotate(100deg)' }} />
)

export const Reddit = () => (
    <svg width={24} viewBox="0 0 216 216" xmlns="http://www.w3.org/2000/svg">
        <defs id="defs101">
            <style id="style2">
                {`
                    .cls-1 {
                        fill: url(#radial-gradient);
                    }
            
                    .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {
                        stroke-width: 0px;
                    }
            
                    .cls-2 {
                        fill: url(#radial-gradient-2);
                    }
            
                    .cls-3 {
                        fill: url(#radial-gradient-3);
                    }
            
                    .cls-4 {
                        fill: url(#radial-gradient-4);
                    }
            
                    .cls-5 {
                        fill: url(#radial-gradient-6);
                    }
            
                    .cls-6 {
                        fill: url(#radial-gradient-8);
                    }
            
                    .cls-7 {
                        fill: url(#radial-gradient-5);
                    }
            
                    .cls-8 {
                        fill: url(#radial-gradient-7);
                    }
            
                    .cls-9 {
                        fill: #842123;
                    }
            
                    .cls-10 {
                        fill: #bbcfda;
                    }
            
                    .cls-11 {
                        fill: #ff6101;
                    }
            
                    .cls-12 {
                        fill: #fff;
                    }
            
                    .cls-13 {
                        fill: #ff4500;
                    }
            
                    .cls-14 {
                        fill: #ffc49c;
                    }
                `}
            </style>
            <radialGradient
                id="radial-gradient"
                cx="370.48999"
                cy="151.59"
                fx="370.48999"
                fy="142.47"
                r="127.45"
                gradientTransform="matrix(1,0,0,0.87,0,19.13)"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#feffff" id="stop4" />
                <stop offset=".4" stopColor="#feffff" id="stop6" />
                <stop offset=".51" stopColor="#f9fcfc" id="stop8" />
                <stop offset=".62" stopColor="#edf3f5" id="stop10" />
                <stop offset=".7" stopColor="#dee9ec" id="stop12" />
                <stop offset=".72" stopColor="#d8e4e8" id="stop14" />
                <stop offset=".76" stopColor="#ccd8df" id="stop16" />
                <stop offset=".8" stopColor="#c8d5dd" id="stop18" />
                <stop offset=".83" stopColor="#ccd6de" id="stop20" />
                <stop offset=".85" stopColor="#d8dbe2" id="stop22" />
                <stop offset=".88" stopColor="#ede3e9" id="stop24" />
                <stop offset=".9" stopColor="#ffebef" id="stop26" />
            </radialGradient>
            <radialGradient
                id="radial-gradient-2"
                cx="64.379997"
                fx="64.379997"
                fy="142.47"
                r="127.45"
                xlinkHref="#radial-gradient"
            />
            <radialGradient
                id="radial-gradient-3"
                cx="220.14"
                cy="135.08"
                fx="220.14"
                fy="135.08"
                r="384.44"
                gradientTransform="matrix(1,0,0,0.7,0,40.35)"
                xlinkHref="#radial-gradient"
            />
            <radialGradient
                id="radial-gradient-4"
                cx="134.7"
                cy="240.48"
                fx="134.7"
                fy="240.48"
                r="32.119999"
                gradientTransform="matrix(1,0,0,1.46,0,-110.04)"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#f60" id="stop31" />
                <stop offset=".5" stopColor="#ff4500" id="stop33" />
                <stop offset=".7" stopColor="#fc4301" id="stop35" />
                <stop offset=".82" stopColor="#f43f07" id="stop37" />
                <stop offset=".92" stopColor="#e53812" id="stop39" />
                <stop offset="1" stopColor="#d4301f" id="stop41" />
            </radialGradient>
            <radialGradient
                id="radial-gradient-5"
                cx="6191.5"
                cy="240.48"
                fx="6191.5"
                fy="240.48"
                r="32.119999"
                gradientTransform="matrix(-1,0,0,1.46,6489.32,-110.04)"
                xlinkHref="#radial-gradient-4"
            />
            <radialGradient
                id="radial-gradient-6"
                cx="215.92999"
                cy="338.51999"
                fx="215.92999"
                fy="338.51999"
                r="113.26"
                gradientTransform="matrix(1,0,0,0.66,0,116.39)"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#172e35" id="stop45" />
                <stop offset=".29" stopColor="#0e1c21" id="stop47" />
                <stop offset=".73" stopColor="#030708" id="stop49" />
                <stop offset="1" stopColor="#000" id="stop51" />
            </radialGradient>
            <radialGradient
                id="radial-gradient-7"
                cx="315.81"
                cy="3.47"
                fx="315.81"
                fy="3.47"
                r="99.419998"
                gradientTransform="matrix(1,0,0,0.98,0,0.06)"
                xlinkHref="#radial-gradient"
            />
            <radialGradient
                id="radial-gradient-8"
                cx="274.38"
                cy="103.82"
                fx="274.38"
                fy="103.82"
                r="81.489998"
                gradientUnits="userSpaceOnUse">
                <stop offset=".48" stopColor="#7a9299" id="stop55" />
                <stop offset=".67" stopColor="#172e35" id="stop57" />
                <stop offset=".75" stopColor="#000" id="stop59" />
                <stop offset=".82" stopColor="#172e35" id="stop61" />
            </radialGradient>
            <symbol id="Snoo" viewBox="0 0 432.21 377.72">
                <g id="g98">
                    <circle className="cls-1" cx="369.16" cy="188.55" r="63.049999" id="circle64" />
                    <circle
                        className="cls-2"
                        cx="63.049999"
                        cy="188.55"
                        r="63.049999"
                        id="circle66"
                    />
                    <ellipse
                        className="cls-3"
                        cx="216.25999"
                        cy="242.72"
                        rx="180"
                        ry="135"
                        id="ellipse68"
                    />
                    <g id="g74">
                        <path
                            className="cls-9"
                            d="m 163.04,229.59 c -1.05,22.87 -16.23,31.17 -33.91,31.17 -17.68,0 -31.15,-11.71 -30.09,-34.58 1.05,-22.87 16.23,-38.01 33.91,-38.01 17.68,0 31.15,18.54 30.09,41.42 z"
                            id="path70"
                        />
                        <path
                            className="cls-9"
                            d="m 333.48,226.18 c 1.05,22.87 -12.42,34.58 -30.09,34.58 -17.67,0 -32.85,-8.3 -33.91,-31.17 -1.05,-22.87 12.42,-41.42 30.09,-41.42 17.67,0 32.85,15.13 33.91,38.01 z"
                            id="path72"
                        />
                    </g>
                    <path
                        className="cls-4"
                        d="m 163.05,231.59 c -0.99,21.41 -15.19,29.17 -31.73,29.17 -16.54,0 -29.15,-11.63 -28.16,-33.03 0.99,-21.41 15.19,-35.41 31.73,-35.41 16.54,0 29.15,17.86 28.16,39.27 z"
                        id="path76"
                    />
                    <path
                        className="cls-7"
                        d="m 269.47,231.59 c 0.99,21.41 15.19,29.17 31.73,29.17 16.54,0 29.15,-11.63 28.16,-33.03 -0.99,-21.41 -15.19,-35.41 -31.73,-35.41 -16.54,0 -29.15,17.86 -28.16,39.27 z"
                        id="path78"
                    />
                    <ellipse
                        className="cls-14"
                        cx="145.19"
                        cy="212.03999"
                        rx="7"
                        ry="7.6399999"
                        id="ellipse80"
                    />
                    <ellipse
                        className="cls-14"
                        cx="311.64001"
                        cy="212.03999"
                        rx="7"
                        ry="7.6399999"
                        id="ellipse82"
                    />
                    <path
                        className="cls-10"
                        d="m 216.26,276.02 c -22.32,0 -43.71,1.08 -63.49,3.04 -3.38,0.34 -5.52,3.78 -4.21,6.86 11.08,25.97 37.22,44.21 67.7,44.21 30.48,0 56.62,-18.24 67.7,-44.21 1.31,-3.08 -0.83,-6.52 -4.21,-6.86 -19.78,-1.97 -41.17,-3.04 -63.49,-3.04 z"
                        id="path84"
                    />
                    <path
                        className="cls-12"
                        d="m 216.26,280.98 c -22.25,0 -43.57,1.09 -63.29,3.09 -3.37,0.34 -5.51,3.84 -4.2,6.97 11.05,26.38 37.1,44.91 67.49,44.91 30.39,0 56.44,-18.53 67.49,-44.91 1.31,-3.12 -0.83,-6.62 -4.2,-6.97 -19.72,-2 -41.04,-3.09 -63.29,-3.09 z"
                        id="path86"
                    />
                    <path
                        className="cls-5"
                        d="m 216.26,278.4 c -21.9,0 -42.89,1.08 -62.3,3.04 -3.32,0.34 -5.42,3.78 -4.13,6.86 10.87,25.97 36.52,44.21 66.44,44.21 29.92,0 55.56,-18.24 66.44,-44.21 1.29,-3.08 -0.81,-6.52 -4.13,-6.86 -19.41,-1.97 -40.4,-3.04 -62.31,-3.04 z"
                        id="path88"
                    />
                    <circle className="cls-8" cx="314.84" cy="44.68" r="44.68" id="circle90" />
                    <path
                        className="cls-6"
                        d="m 215.62,113.41 c -5.35,0 -9.69,-2.24 -9.69,-5.69 0,-40.03 32.56,-72.59 72.59,-72.59 5.35,0 9.69,4.34 9.69,9.69 0,5.35 -4.34,9.69 -9.69,9.69 -29.34,0 -53.22,23.87 -53.22,53.22 0,3.45 -4.34,5.69 -9.69,5.69 z"
                        id="path92"
                    />
                    <path
                        className="cls-11"
                        d="m 151.29,242.18 c 0,8.28 -8.81,12 -19.69,12 -10.88,0 -19.69,-3.72 -19.69,-12 0,-8.28 8.81,-15 19.69,-15 10.88,0 19.69,6.72 19.69,15 z"
                        id="path94"
                    />
                    <path
                        className="cls-11"
                        d="m 320.6,242.18 c 0,8.28 -8.81,12 -19.69,12 -10.88,0 -19.69,-3.72 -19.69,-12 0,-8.28 8.81,-15 19.69,-15 10.88,0 19.69,6.72 19.69,15 z"
                        id="path96"
                    />
                </g>
            </symbol>
        </defs>
        <path
            className="cls-13"
            d="M 108,0 V 0 C 48.35,0 0,48.35 0,108 v 0 c 0,29.82 12.09,56.82 31.63,76.37 L 11.06,204.94 C 6.98,209.02 9.87,216 15.64,216 H 108 c 0,0 0,0 0,0 59.65,0 108,-48.35 108,-108 v 0 C 216,48.35 167.65,0 108,0 Z"
            id="path103"
        />
        <use
            width="432.20999"
            height="377.72"
            transform="matrix(0.4,0,0,0.4,21.56,31.55)"
            xlinkHref="#Snoo"
            id="use105"
        />
    </svg>
)

export const Criteo = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 600 480"
            version="1.1"
            // style={fillRule:'evenodd',clipRule:'even'}"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
        >
            <path
                d="M3.675,141.021C-16.021,169.54 -27.964,202.455 -27.741,239.903C-29.752,257.704 -29.426,275.746 -25.91,293.329C-17.782,333.968 9.61,367.012 35.129,397.998C47.723,413.292 60.224,429.744 76.296,441.798C105.608,463.782 146.128,466.313 180.558,461.395C189.336,460.141 198.483,460.753 207.192,459.216C212.641,458.255 217.613,455.546 223.005,454.391C248.715,448.881 262.328,445.122 284.084,429.582C288.289,426.578 293.803,424.838 298.264,422.049C316.73,410.508 326.698,392.777 330.51,373.099C331.699,369.954 334.459,362.35 334.99,358.343C336.056,350.295 334.668,342.935 331.498,336.596C329.437,332.473 323.52,328.626 317.21,325.523C308.33,317.366 297.455,314.202 285.664,315.509C271.402,317.091 254.519,328.89 247.323,339.171C239.226,350.737 231.76,364.545 221.236,374.112C215.247,379.557 207.138,381.286 199.802,384.307C191.778,387.611 183.205,389.664 175.23,392.987C172.92,393.95 168.976,395.885 167.406,396.668C163.042,397.219 157.908,396.564 153.647,396.328C143.296,395.753 134.997,391.255 125.914,386.713C106.338,376.925 89.034,365.21 76.677,346.674C70.395,337.252 66.677,326.648 61.504,316.646C49.759,293.94 37.261,268.843 36.322,242.767C37.838,232.182 40.549,221.742 43.88,211.747C48.169,198.88 52.29,185.938 58.602,173.956C70.33,157.919 85.762,143.959 102.567,131.696C125.344,115.075 149.608,103.784 177.755,101.501C185.565,100.868 193.973,99.601 202.129,99.803C204.875,99.99 207.618,100.253 210.353,100.585C212.884,101.038 215.356,101.719 217.745,102.693C228.806,107.199 241.126,111.257 251.599,116.97C257.393,120.13 261.921,125.177 267.508,128.669C270.338,130.437 275.734,132.811 278.728,134.074C280.541,136.109 282.19,138.125 283.283,140.374C284.057,146.545 285.668,156.903 288.083,161.072C294.294,171.794 303.816,178.69 318.696,178.69C336.357,178.69 350.696,164.352 350.696,146.69C350.696,140.58 348.979,134.867 346,130.009C345.673,126.712 345.239,123.401 344.739,121.902C343.531,118.277 341.999,114.753 340.184,111.309C340.099,108.079 339.513,104.808 338.385,101.597C335.406,93.125 329.215,86.693 321.656,83.194C320.707,82.194 319.775,81.235 319.322,80.82C308.275,70.693 293.92,59.633 280.103,53.712C237.347,35.388 188.517,30.437 143.097,40.693C90.022,52.678 37.489,86.394 8.246,133.182C6.637,135.756 5.115,138.368 3.675,141.021ZM315.309,324.6C309.061,321.236 297.912,317.945 297.912,317.945C297.912,317.945 306.648,320.547 315.309,324.6Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M326.638,151.437C326.082,149.351 325.426,147.017 324.958,145.707C321.529,136.106 316.042,128.321 309.472,120.555C291.759,99.622 262.424,80.033 236.26,72.07C219.615,67.004 200.367,65.936 183.064,65.244C128.748,63.071 75.659,71.332 36.846,114.711C22.946,130.245 16.595,151.043 10.202,170.224C7.049,179.681 3.724,189.136 1.904,198.964C-3.475,228.009 3.215,260.448 10.437,288.434C14.471,304.065 16.615,320.014 20.944,335.598C25.671,352.615 43.325,362.593 60.341,357.866C77.358,353.139 87.336,335.486 82.609,318.469C78.386,303.264 76.343,287.692 72.407,272.441C67.402,253.047 61.106,230.746 64.834,210.618C66.115,203.701 68.698,197.119 70.917,190.462C74.632,179.319 76.466,166.41 84.541,157.386C109.691,129.277 145.311,127.785 180.506,129.193C192.555,129.675 206.035,129.769 217.625,133.297C233.01,137.979 250.2,149.587 260.615,161.896C262.108,163.66 263.908,165.05 264.687,167.232C266.672,172.79 268.442,181.06 272.147,186.961C276.953,194.613 283.631,200.409 292.498,203.723C309.042,209.905 327.493,201.493 333.675,184.949C338.145,172.987 334.986,160.029 326.638,151.437Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M290.148,148.193C278.995,160.752 279.436,180.01 291.466,192.04C303.955,204.529 324.233,204.529 336.721,192.04C349.331,179.431 354.908,155.401 357.042,139.036L357.06,138.853C359.973,133.739 361.502,127.76 361.178,121.451C360.516,108.6 352.343,97.902 341.131,93.4C339.279,92.072 337.68,91.1 336.667,90.816C325.324,87.638 314.702,89.609 305.273,99.039C301.977,102.335 298.688,107.026 296.559,113.196C294.75,118.438 294.03,127.313 293.58,130.759C292.977,135.385 290.587,146.226 290.148,148.193Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M293.123,373.878C299.901,386.445 314.564,393.337 329.046,389.717C346.18,385.433 356.613,368.045 352.329,350.911C350.319,342.872 337.959,328.261 337.959,328.261C337.959,328.261 338.464,328.846 338.681,329.123C332.005,320.627 325.497,311.98 317.262,304.869C315.363,300.603 312.498,296.691 308.697,293.479C295.207,282.079 275.001,283.775 263.601,297.264C255.806,306.487 253.546,317.162 256.87,328.863C257.969,332.73 259.922,336.986 262.954,341.104C266.52,345.948 273.176,351.388 275.303,353.187C280.508,357.591 284.18,363.347 288.356,368.663C289.416,370.012 291.59,372.306 293.123,373.878ZM318.051,329.038C316.8,332.428 314.947,335.658 312.483,338.575C315.026,335.565 316.882,332.382 318.051,329.038ZM318.362,328.137L318.217,328.568L318.336,328.228L318.362,328.137Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M375.209,203.884C381.474,211.053 389.032,222.509 389.761,231.982C390.842,246.037 387.532,260.518 383.538,273.831C382.447,277.469 380.635,281.363 377.635,283.727C375.676,284.143 372.391,284.879 370.478,285.453C370.039,285.585 369.324,285.66 368.695,285.7C356.179,276.494 338.454,277.552 327.132,288.874C314.644,301.362 314.644,321.64 327.132,334.129C342.019,349.016 369.054,352.698 388.868,346.754C395.048,344.9 401.556,343.813 407.294,340.625C425.388,330.572 438.97,311.784 444.839,292.221C451.044,271.538 455.252,248.909 453.572,227.073C451.882,205.101 436.911,176.939 422.574,160.809C415.144,152.451 405.931,148.87 397.368,143.035C382.773,133.09 362.849,136.865 352.904,151.46C342.959,166.055 346.734,185.979 361.329,195.924C364.272,197.929 367.322,199.649 370.415,201.273L375.209,203.884Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M493.051,104.602C506.997,105.533 521.097,108.522 534.038,113.699C564.402,125.845 580.936,164.476 574.412,196.007C570.735,213.782 565.519,232.657 556.009,248.219C551.892,254.956 545.296,259.85 540.837,266.335C535.03,274.783 530.2,285.655 521.633,291.76C517.564,292.548 510.201,294.16 506.3,296.111C502.784,297.869 497.702,297.597 493.569,296.564C490.96,295.912 488.261,295.336 485.604,294.893C483.451,294.535 469.763,292.064 462.398,292.255C453.262,292.491 446.532,295.54 442.669,298.074C432.699,304.613 428.291,313.682 427.791,324.01C427.495,330.124 428.071,339.862 438.157,349.948C447.176,358.967 460.258,361.473 471.531,357.462L475.082,358.023C476.072,358.188 477.075,358.41 478.047,358.653C495.49,363.014 516.518,361.455 532.076,354.676C536.238,353.882 545.857,351.805 551.156,348.777C569.385,338.36 582.091,319.298 593.576,302.593C598.679,295.17 605.907,289.303 610.619,281.592C623.896,259.865 631.951,233.791 637.085,208.974C649.454,149.189 615.381,77.306 557.807,54.276C537.479,46.145 515.236,41.56 493.37,40.519C486.379,40.186 471.247,40.788 463.598,44.771C449.774,51.968 441.432,63.669 444.975,83.012C448.157,100.385 464.844,111.905 482.216,108.724C486.167,108 489.815,106.578 493.051,104.602ZM485.086,306.516L485.391,306.871L485.358,306.829L485.086,306.516ZM484.477,305.814C484.14,305.441 483.785,305.067 483.412,304.693L484.477,305.814ZM508.187,73.144L508.228,73.535L508.192,73.178L508.187,73.144Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M451.15,360.52C452.229,361.941 453.317,363.342 454.034,364.202C461.593,373.272 471.044,381.144 480.014,388.785C495.086,401.624 510.98,413.66 526.363,426.113C526.969,426.603 528.259,427.723 529.336,428.666C533.979,440.599 545.586,449.061 559.153,449.061C576.814,449.061 591.153,434.722 591.153,417.061C591.153,409.692 588.869,401.523 583.724,393.857C579.096,386.961 571.083,379.973 566.632,376.369C551.663,364.252 536.182,352.559 521.515,340.065C515.277,334.751 508.458,329.539 503.2,323.23C499.244,318.482 492.639,310.195 490.071,308.211C484.619,303.999 479.44,302.457 475.701,301.785C463.572,299.603 454.116,303.494 446.745,311.152C443.217,314.818 435.439,323.051 438.166,339.669C439.601,348.411 444.461,355.744 451.15,360.52ZM496.544,351.956C500.198,347.204 503.088,340.066 501.321,329.303C502.668,337.507 500.76,345.498 496.544,351.956Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M340.846,356.164C342.549,364.939 343.234,373.974 344.594,382.809C347.029,398.641 346.81,414.591 346.81,430.579C346.81,435.689 345.74,448.743 347.576,456.399C349.49,464.384 353.327,470.485 357.621,474.779C370.109,487.267 390.387,487.267 402.876,474.779C411.97,465.685 414.442,452.46 410.283,441.122C410.481,437.968 410.81,432.366 410.81,430.579C410.81,411.329 410.782,392.139 407.849,373.078C406.163,362.116 405.242,350.907 402.889,340.082C402.224,337.02 400.356,332.758 398.561,329.114C396.518,321.302 391.536,314.258 384.072,309.784C363.817,297.644 350.682,308.781 346.838,311.83C340.442,316.903 335.527,324.104 334.765,334.694C334.531,337.946 334.637,342.488 336.579,347.947C336.942,348.968 339.471,353.656 340.846,356.164ZM359.847,368.274C356.865,367.533 353.942,366.34 351.17,364.679C354.421,366.627 357.341,367.701 359.847,368.274Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M340.524,39.162C338.144,39.075 335.755,39.129 333.353,39.332L331.906,39.331C302.702,39.41 299.927,71.145 299.927,71.332C299.927,81.529 303.531,94.934 320.839,101.47C323.121,102.332 327.124,103.497 332.289,103.68C334.058,103.743 336.527,103.645 338.672,103.519C343.429,105.532 350.583,111.272 353.047,114.969C355.895,119.24 358.55,123.654 361.389,127.912C363.64,131.29 367.955,136.925 371.055,140.892C368.536,143.389 363.445,148.577 361.898,151.186C358.293,157.262 357.165,163.236 357.165,168.262C357.165,185.924 371.503,200.262 389.165,200.262C399.61,200.262 408.892,195.247 414.732,187.496L416.394,186C425.924,176.471 433.767,166.982 436.798,153.345C439.899,139.387 437.251,126.814 431.066,115.259C428.685,110.811 425.479,106.598 422.276,102.527L430.381,103.626C442.246,105.208 454.028,105.523 465.878,107.498C473.515,108.771 480.743,108.996 488.301,109.904C491.252,111.05 494.422,111.773 497.744,111.994C515.366,113.171 530.628,99.819 531.804,82.197C533.021,63.979 495.821,46.379 495.821,46.379C495.821,46.379 496.582,46.434 496.968,46.482C490.02,45.613 483.398,45.536 476.4,44.369C463.857,42.279 451.397,41.862 438.839,40.188C415.113,37.024 392.518,33.918 368.435,36.327C359.112,37.259 349.823,38.288 340.524,39.162ZM469.169,89.089C468.131,85.566 467.688,81.807 467.946,77.934C467.665,82.15 468.15,85.832 469.169,89.089Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M397.994,130.642C399.475,133.534 398.296,137.135 397.941,140.57C397.284,146.932 395.979,153.213 395.016,158.829C394.532,161.656 393.364,167.009 393.179,167.85C383.449,182.166 386.893,201.733 401.054,211.847C415.425,222.113 435.427,218.779 445.693,204.407C453.054,194.101 455.994,181.903 458.096,169.643C461.96,147.103 465.255,118.007 452.453,96.975C446.576,87.32 440.565,81.999 434.414,77.891C430.903,75.546 426.986,74.617 422.577,70.943C409.009,59.637 388.815,61.473 377.508,75.041C366.202,88.609 368.038,108.803 381.606,120.11C384.829,122.796 387.888,124.884 390.828,126.654C392.971,127.943 396.393,129.791 397.994,130.642Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M416.46,71.678C402.689,82.14 399.714,101.77 409.9,115.869C414.44,122.154 420.845,126.301 427.816,128.101L427.955,128.781C430.194,144.453 426.25,160.858 421.962,175.866C420.975,179.319 417.794,186.377 416.999,188.119C402.607,196.524 396.989,214.791 404.506,229.943C412.355,245.764 431.572,252.236 447.394,244.387C466.2,235.057 478.183,212.057 483.499,193.448C490.196,170.008 494.809,144.207 491.312,119.73C490.299,112.641 485.667,93.028 478.301,81.474C469.784,68.114 457.636,61.726 445.865,60.97C433.261,60.16 416.769,71.465 416.46,71.678ZM416.46,71.678L417.1,71.191C416.88,71.35 416.456,71.681 416.456,71.681L416.46,71.678Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M473.091,137.025C473.241,138.644 473.348,140.16 473.374,141.346C474.039,171.952 461.298,209.31 427.974,212.643C410.401,214.4 397.56,230.094 399.317,247.668C401.075,265.242 416.769,278.082 434.343,276.325C501.722,269.587 538.704,201.84 537.359,139.955C537.093,127.733 535.683,113.087 531.041,101.658C522.722,81.178 507.267,66.908 478.912,68.798C467.41,69.565 456.898,73.985 448.513,82.022C435.763,94.243 435.333,114.516 447.553,127.267C454.439,134.45 463.88,137.723 473.091,137.025Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M511.919,140.323C512.009,143.896 512.049,148.301 511.826,150.268C509.332,172.217 495.182,193.609 476.557,205.303C474.475,206.611 469.616,208.624 466.648,209.798C454.439,203.107 438.795,204.988 428.529,215.378C416.116,227.941 416.238,248.219 428.802,260.632C440.254,271.947 455.306,276.214 471.555,274.336C485.699,272.701 501.004,265.523 510.59,259.504C545.028,237.881 570.805,198.078 575.416,157.494C576.86,144.788 576.451,119.321 567.895,104.479C560.22,91.165 548.336,82.502 531.137,81.482C513.506,80.436 498.344,93.901 497.298,111.531C496.59,123.467 502.533,134.271 511.919,140.323Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M539.113,170.826L538.871,171.517C537.817,174.258 535.673,178.692 534.65,180.812C531.308,187.735 527.602,194.24 523.108,200.487C514.677,212.209 503.438,224.792 490.248,234.013C480.242,241.007 469.116,246.384 457.114,245.384C439.514,243.917 424.034,257.016 422.567,274.616C421.1,292.216 434.199,307.696 451.799,309.163C501.66,313.318 548.492,274.799 575.064,237.858C581.746,228.569 587.316,218.93 592.285,208.636C593.839,205.418 597.006,198.651 598.606,194.492C603.388,182.058 607.507,163.36 605.861,148.414C604.387,135.031 598.89,123.819 590.297,115.905C581.565,107.863 569.013,101.845 550.173,103.829C543.219,104.56 536.654,106.597 530.184,109.112C513.722,115.51 505.552,134.07 511.951,150.531C516.525,162.301 527.317,169.832 539.113,170.826Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M528.087,236.205C527.609,237.219 527.152,238.091 526.77,238.685C524.981,241.469 522.855,244.253 520.636,246.732C507.56,261.346 491.722,267.117 472.636,267.425C465.3,267.543 457.529,268.347 450.667,265.406C434.434,258.449 415.606,265.98 408.649,282.213C401.692,298.447 409.223,317.274 425.456,324.232C440.617,330.729 457.46,331.678 473.668,331.417C511.484,330.807 542.423,318.363 568.332,289.407C572.773,284.444 577.023,278.867 580.606,273.293C587.898,261.949 597.228,239.573 596.108,223.304C595.313,211.762 590.89,201.886 583.2,194.268C576.571,187.7 566.964,182.073 552.277,181.081C534.656,179.89 519.383,193.229 518.192,210.85C517.524,220.73 521.425,229.872 528.087,236.205Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M556.114,336.787C562.177,321.527 555.634,303.878 540.674,296.398C524.877,288.5 505.64,294.912 497.742,310.709C495.438,315.316 494.543,318.717 493.467,323.697C489.738,340.96 500.727,358.002 517.99,361.731C535.253,365.46 552.296,354.472 556.024,337.209L556.114,336.787Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M477.575,364.07C480.023,367.198 482.884,370.219 484.942,373.595C489.598,381.238 494.571,388.784 499.428,396.376C493.911,398.631 487.543,401.388 482.746,404.644C472.856,411.357 466.763,420.158 464.243,428.979C460.049,443.658 463.666,457.618 479.808,467.017C485.528,470.348 506.033,473.117 506.033,473.117C506.033,473.117 504.674,472.991 504.301,472.941C507.991,473.433 511.927,473.847 515.996,474.111C526.452,479.647 539.344,478.979 549.214,472.104C553.839,471.034 558.24,469.545 562.246,467.542C576.373,460.479 578.454,449.941 579.419,445.209C580.614,439.343 580.708,433.202 578.712,427.437C579.927,423.363 580.44,418.59 579.5,412.951C577.796,402.724 570.98,391.309 565.94,382.489C557.772,368.195 548.185,354.393 539.597,340.298C536.246,334.797 531.816,329.673 527.91,324.565L527.15,323.644C522.319,312.781 511.6,305.044 498.931,304.633C481.279,304.061 466.483,317.928 465.911,335.58C465.615,344.735 477.245,363.538 477.575,364.07ZM554.35,469.67C554.634,469.569 554.819,469.491 554.819,469.491L554.35,469.67ZM541.136,450.855L541.078,450.858C541.078,450.858 541.644,450.922 541.874,450.943L541.136,450.855ZM477.575,364.07L477.071,363.442C477.226,363.645 477.582,364.082 477.582,364.082L477.575,364.07Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M365.636,373.132C365.497,373.933 365.398,374.748 365.329,375.574C365.2,377.125 365.034,378.674 364.964,380.23C364.172,397.657 370.636,403.985 370.732,404.119C371.474,405.16 425.914,426.753 428.747,387.304L429.589,373.828C431.905,359.722 429.255,347.81 428.525,333.712C427.613,316.074 412.553,302.495 394.915,303.407C377.278,304.32 363.699,319.38 364.611,337.018C365.094,346.354 368.317,354.105 366.415,363.614C366.352,363.93 365.989,368.527 365.636,373.132Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
            <path
                d="M365.887,347.88C365.562,351.126 365.377,354.396 365.548,357.723C365.622,359.171 365.711,360.619 365.815,362.067L365.83,363.845C365.86,365.821 366.07,367.753 366.452,369.623C368.14,386.87 371.269,403.97 373.18,421.17C375.13,438.723 390.965,451.391 408.518,449.44C426.071,447.49 438.739,431.656 436.789,414.102C434.766,395.898 431.171,377.828 429.795,359.531C429.757,354.526 429.832,349.523 429.993,344.525C430.612,339.548 431.519,334.631 431.519,329.622C431.519,314.073 423.496,308.055 421.952,306.534C415.792,300.464 408.929,298.006 402.174,297.436C395.802,296.899 378.599,296.666 370.01,316.827C369.538,317.936 367.488,326.006 367.01,329.189C366.936,329.683 366.11,339.745 366.102,339.985C366.008,342.616 365.933,345.248 365.887,347.88Z"
                style={{ fill: 'rgb(255,95,0)' }}
            />
        </svg>
    )
}

export const Roomburg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={24} viewBox="0 0 137 159">
        <path
            style={{ fill: '#ed7b22', fillOpacity: 1 }}
            d="m 24.997202,157.75 c -0.0015,-0.6875 1.207125,-6.5375 2.68592,-13 L 30.371838,133 h 9.220461 c 8.244604,0 9.184379,0.18521 8.879532,1.75 -0.187512,0.9625 -0.8315,5.35 -1.431085,9.75 -0.599585,4.4 -1.324429,9.4625 -1.610764,11.25 L 44.909374,159 h -9.954687 c -7.295591,0 -9.955434,-0.3339 -9.957485,-1.25 z M 56,158.46788 c 0,-1.67213 3.0231,-7.23425 4.784368,-8.80263 C 67.075116,144.06347 80,148.81034 80,156.72251 80,158.96597 79.8207,159 68,159 61.4,159 56,158.76055 56,158.46788 Z M 91.525635,157.75 c -0.226378,-0.6875 -0.9042,-5.525 -1.50627,-10.75 -0.602071,-5.225 -1.315584,-10.52956 -1.585585,-11.7879 -0.486985,-2.26961 -0.417126,-2.28561 8.73601,-2 l 9.22692,0.2879 2.22292,9.5 c 1.22261,5.225 2.50374,10.9625 2.84696,12.75 l 0.62404,3.25 h -10.0767 c -7.175176,0 -10.195216,-0.35993 -10.488295,-1.25 z m -6.840766,-3.57566 c -0.773112,-3.86555 -5.326444,-9.12663 -9.356059,-10.81031 -4.252701,-1.7769 -10.70416,-1.73841 -14.230026,0.0849 C 57.564428,145.2766 52,151.54662 52,153.70146 c 0,0.89753 -0.225409,1.40646 -0.500909,1.13096 -0.2755,-0.2755 -0.03029,-4.288 0.544919,-8.91666 C 53.843626,131.43428 51.846435,133 68.519052,133 77.204967,133 83,133.38807 83,133.96973 c 0,0.53335 0.709939,5.74841 1.577642,11.58902 0.867703,5.84061 1.377078,10.81986 1.131945,11.065 -0.245134,0.24513 -0.706257,-0.8571 -1.024718,-2.44941 z M 31.991812,127.25 c -0.0045,-0.4125 1.426767,-6.9375 3.1806,-14.5 L 38.361199,99 H 45.6806 C 49.719787,99 53,99.432745 53,99.965618 53,101.52384 50.016553,123.28875 49.465579,125.75 c -0.473881,2.11687 -1.00548,2.25 -8.984631,2.25 -4.664521,0 -8.484633,-0.3375 -8.489136,-0.75 z m 22.995353,-0.5 c -0.0071,-0.6875 0.747851,-7.18433 1.677579,-14.4374 L 58.355157,99.125193 68.181421,98.812597 78.007684,98.5 l 0.511251,3 C 79.20734,105.53953 82,126.13637 82,127.17407 82,127.62833 75.925,128 68.5,128 58.373512,128 54.996793,127.68764 54.987165,126.75 Z M 85.676704,115.19782 C 83.321199,97.212768 82.75475,98.861363 91.171349,99.20619 L 98.342699,99.5 101.62506,113 c 1.8053,7.425 3.30319,13.8375 3.32865,14.25 0.0255,0.4125 -3.92419,0.75 -8.777006,0.75 H 87.353408 Z M 4.3265286,114.55821 c -5.3528139,-3.85283 -4.89241666,-13.99695 0.6062159,-13.357 C 7.1284395,101.45676 7.5,101.99325 7.5,104.90803 c 0,1.87988 0.5753203,3.60367 1.2830611,3.84435 C 10.203204,109.23532 63.5,57.197975 63.5,55.328448 63.5,54.684095 52.108217,42.651005 38.184926,28.588248 24.261636,14.525492 13.150693,2.56519 13.493943,2.0098 13.837193,1.45441 14.650791,1 15.30194,1 15.953088,1 28.068689,12.576418 42.225498,26.725373 L 67.965151,52.450746 83.232575,37.459893 C 109.70288,11.469108 120.06296,1.5095028 120.95339,1.1972136 c 0.47483,-0.1665325 1.16756,0.189476 1.53941,0.7911301 C 122.87902,2.6132751 112.26035,14.318558 97.724532,29.29113 L 72.28019,55.5 99.03432,81.75 c 14.71477,14.4375 27.47673,26.25 28.3599,26.25 1.16851,0 1.60578,-0.95309 1.60578,-3.5 0,-3.05334 0.31455,-3.5 2.46482,-3.5 3.17937,0 4.90723,3.20328 4.0868,7.57655 -0.79401,4.23245 -3.84882,6.41588 -9.02413,6.45002 -3.95654,0.0261 -4.50956,-0.46068 -31.393558,-27.633795 L 67.767864,59.73241 62.195843,66.116205 C 54.723307,74.677396 21.448136,108.398 16.783599,112.13636 12.246971,115.7722 7.3388542,116.72642 4.3265286,114.55821 Z M 41,92.724972 c 0,-0.151265 3.394268,-3.638765 7.542818,-7.75 L 56.085636,77.5 55.490579,82 c -0.327282,2.475 -0.816941,5.9625 -1.088131,7.75 L 53.909374,93 H 47.454687 C 43.904609,93 41,92.876238 41,92.724972 Z M 59.363474,91.25 c 0.274037,-0.9625 1.039121,-5.882146 1.700187,-10.932548 1.083281,-8.276033 1.519642,-9.490478 4.420123,-12.301734 l 3.218184,-3.119188 3.001036,3.417992 c 2.560732,2.916512 3.169466,4.731329 4.149016,12.36946 C 77.586614,94.209623 78.364422,93 67.932612,93 c -8.15875,0 -9.017458,-0.175367 -8.569138,-1.75 z m 23.263324,0 C 82.34741,90.2875 81.819476,86.8 81.453609,83.5 l -0.665211,-6 7.605801,7.474972 C 92.57739,89.086207 96,92.573707 96,92.724972 96,92.876238 93.105324,93 89.567388,93 c -5.266116,0 -6.52473,-0.317347 -6.94059,-1.75 z M 45.740614,57.290493 c 0.20483,-6.484771 0.459486,-12.370645 0.565902,-13.079719 0.106416,-0.709075 3.005965,1.553013 6.443441,5.026862 l 6.249957,6.316088 -6.815859,6.763631 -6.815859,6.763632 z M 83.716262,62.22467 76.932523,55.38181 83.716262,48.940905 90.5,42.5 l 0.29569,6.75 c 0.162629,3.7125 0.162629,9.690194 0,13.283765 L 90.5,69.067531 Z M 60.418931,38.91082 C 51.891568,30.32493 51.978859,30.853774 58.5,27.285058 c 4.613514,-2.52476 14.975505,-2.259911 20.25,0.517584 2.3375,1.230903 4.234641,2.56636 4.215869,2.967682 -0.01877,0.401322 -3.317754,4.191099 -7.331069,8.421728 l -7.296937,7.692051 z"
        />
    </svg>
)

export const DatHuis = () => (
    <svg height={24} viewBox="0 0 40 90" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-330.000000, -70.000000)" fill="#244561">
                <g transform="translate(220.000000, 70.000000)">
                    <g transform="translate(85.000000, 0.000000)">
                        <g transform="translate(25.000000, 0.000000)">
                            <path d="M38.7598,23.28 L29.2808,23.28 C29.0398,23.28 28.7998,23.52 28.7998,23.88 L28.7998,41.28 L9.3608,41.28 L9.3608,21.6 L17.8798,21.6 C18.2398,21.6 18.4798,21.36 18.4798,21.12 L18.4798,11.52 C18.4798,11.16 18.2398,10.92 17.8798,10.92 L9.3608,10.92 L9.3608,0.6 C9.3608,0.24 9.1198,0 8.7598,0 L0.4798,0 C0.2398,0 -0.0002,0.24 -0.0002,0.6 L-0.0002,61.08 C-0.0002,61.44 0.2398,61.68 0.4798,61.68 L8.7598,61.68 C9.1198,61.68 9.3608,61.44 9.3608,61.08 L9.3608,51 L28.7998,51 L28.7998,88.44 C28.7998,88.8 29.0398,89.04 29.2808,89.04 L38.7598,89.04 C38.9998,89.04 39.2398,88.8 39.2398,88.44 L39.2398,23.88 C39.2398,23.52 38.9998,23.28 38.7598,23.28" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
